module.exports = __webpack_public_path__ + "static/assets/e88aa1914f6e26f67ed981ecc1cd8f1a.png";